
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 27.328c1.442-2.092 3.755-3.102 6.01-4.143 1.783-.822 3.654-1.473 5.476-2.221.314-.131.701-.308.85-.565 2.784-4.85 5.451-9.756 7.021-15.097.213-.724.019-1.553.014-2.332-.82.104-1.718.048-2.45.344-3.572 1.447-6.755 3.45-9.399 6.158-1.385 1.416-2.306 3.035-2.408 4.998-.007.155-.004.326-.07.46-.268.566-.435 1.458-.874 1.605-.79.26-1.202-.574-1.565-1.159-.804-1.298-.843-2.651-.28-4.043.914-2.258 2.604-3.962 4.507-5.492 3.375-2.706 7.112-4.807 11.506-5.688.86-.173 1.785-.181 2.665-.114 1.695.127 2.77 1.198 2.943 2.787.199 1.81-.158 3.576-.938 5.193-1.787 3.707-3.727 7.348-5.607 11.016-.155.301-.334.593-.563 1 1.183-.173 2.22-.348 3.264-.47.524-.06 1.082-.113 1.577.002.276.066.586.467.632.753.028.173-.389.52-.667.602-1.576.467-3.188.834-4.757 1.325-1.132.353-1.929 1.084-2.57 2.08-1.63 2.524-3.656 4.756-6.3 6.403-.863.54-1.886.853-2.836 1.27H7.785C5.963 31.53 4.67 30.505 4 28.823v-1.495zm9.73-2.537a14.81 14.81 0 00-6.653 3.125c-.38.311-.56.837-.834 1.263.588.024 1.176.05 1.767.07.062.002.127-.033.187-.057 2.35-.886 4.059-2.494 5.534-4.401z","fill":"currentColor"}})])
          )
        }
      }
    